import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { StripePaymentContextProvider } from "../../components/stripe/StripePaymentContext";
import { BillingProfilesPage } from "../../pages/billing-profiles/BillingProfilesPage";
import { CreateBillingProfilePage } from "../../pages/billing-profiles/new-billing-profile/CreateBillingProfilePage";
import { BillingProfileDetailsPage } from "../../pages/billing-profiles/view-billing-profile/BillingProfileDetailsPage";
import { InvoiceDetailPage } from "../../pages/invoices/InvoiceDetailPage";
import { InvoicesPage } from "../../pages/invoices/InvoicesPage";
import { PaymentProfilesPage } from "../../pages/payment-profiles/PaymentProfilesPage";

export function BillingRoutes() {
  return (
    <Routes>
      <Route path="/billing-profiles" element={<BillingProfilesPage />} />
      <Route path="/payment-profiles/*" element={<PaymentProfilesPage />} />

      <Route
        path="/billing-profiles/create"
        element={<CreateBillingProfilePage />}
      />
      <Route
        path="/billing-profiles/:billingProfileId/*"
        element={<BillingProfileDetailsPage />}
      />
      <Route
        path="/invoices"
        element={<Navigate to="/billing/invoices/current" replace />}
      />
      <Route path="/invoices/current" element={<InvoicesPage />} />
      <Route path="/invoices/historical" element={<InvoicesPage />} />
      <Route
        path="/invoices/current/:invoiceId"
        element={
          <StripePaymentContextProvider>
            <InvoiceDetailPage />
          </StripePaymentContextProvider>
        }
      />
      <Route
        path="/invoices/historical/:invoiceId"
        element={
          <StripePaymentContextProvider>
            <InvoiceDetailPage />
          </StripePaymentContextProvider>
        }
      />
      <Route
        path="/invoices/:invoiceId"
        element={
          <StripePaymentContextProvider>
            <InvoiceDetailPage />
          </StripePaymentContextProvider>
        }
      />
    </Routes>
  );
}
